<mat-sidenav-container fullscreen>
	<mat-menu #menu="matMenu">
		<mat-nav-list>
			<button mat-menu-item routerLink="/home" routerLinkActive="active-route">
				<mat-icon mat-list-icon>home</mat-icon>
				<span matLine>Inicial</span>
			</button>
			<mat-divider></mat-divider>
			<button mat-menu-item routerLink="/lista-cotacoes" routerLinkActive="active-route">
				<mat-icon mat-list-icon>assignment</mat-icon>
				<span matLine>Cotações</span>
			</button>
			<mat-divider></mat-divider>
			<button mat-menu-item (click)="logout()">
				<mat-icon mat-list-icon>exit_to_app</mat-icon>
				<span matLine>Logout</span>
			</button>
		</mat-nav-list>
	</mat-menu>
	<mat-toolbar color="primary">
		<button mat-icon-button style="margin-right: 25px;" [matMenuTriggerFor]="menu">
			<mat-icon>menu</mat-icon>
		</button>
		<span class="app-fill-remaining-space"></span>
		<img id="clienteImage" src="assets/images/sua_logo.png" class="logo-filial" alt="Avatar" />
		<img src="assets/images/favicon.png" class="logo-filial" alt="Avatar" />
	</mat-toolbar>

<div class="app-content" style="padding: 0px !important;">
  <div class="middle-layer">
    <div class="app-content" layout="column" [ngStyle]="appContentStyle"> 
      <meta charset="utf-8"/>
      
      <div id="topo"> 
        <mat-toolbar id="topo">
          <button mat-raised-button (click)="abaAtual = 0">Cabeçalhos</button>
          <button mat-raised-button (click)="abaAtual = 1">Itens</button>
        </mat-toolbar>
        
    
        <div *ngIf="0 === abaAtual" id="cabecalhos">
          <div class="custom-max-width" *ngIf="areAllLoadSuccess()">
            <div *ngFor="let solicitacao of getTodasCotacoesArray()">
              <div class="item-espaco">
                <div [ngClass]="{'custom-toolbar sombra': true}">
                  <div [ngClass]="{'custom-toolbar-header': true}">
                    Cotação {{solicitacao.nrSolicitacao}}
                  </div>
                  <div [ngClass]="{'custom-toolbar-body': true}">
                    <div class="list">
                      <div class="item">
                        <div class="line">
                          <mat-form-field>
                            <mat-label>Data Validade</mat-label>
                            <input matInput [(ngModel)]="solicitacao.cotacao.dtValidade"
                              name="dtValidade" placeholder="Dt. Validade">
                          </mat-form-field>
                          <mat-form-field>
                            <mat-label>Dt. Faturamento</mat-label>
                            <input matInput [(ngModel)]="solicitacao.cotacao.dtFaturamento"
                              name="dtFaturamento" placeholder="Dt. Faturamento">
                          </mat-form-field>
                          <mat-form-field class="field-prev-entrega">
                            <mat-label>Prev. Entrega</mat-label>
                            <input matInput [(ngModel)]="solicitacao.cotacao.diasPrevEntrega"
                              placeholder="Prev. Entrega" name="prevEntrega" type="number" min="0">
                            <span matSuffix>dias</span>
                          </mat-form-field>
                          <mat-form-field class="field-prazo-pgto">
                            <mat-label>Prazo de Pagamento</mat-label>
                            <input matInput [(ngModel)]="solicitacao.cotacao.prazoPagamento"
                              placeholder="Prazo de Pagamento" name="prazoPgto" maxlength="30">
                          </mat-form-field>
                          <mat-form-field class="field-tipo-frete">
                            <mat-label>Tipo Frete</mat-label>
                            <mat-select id="selectTipoFrete" [(ngModel)]="solicitacao.cotacao.tpFrete"
                              name="tpFrete" placeholder="Tipo Frete" class="select-tipo-frete"
                              required>
                              <mat-option *ngFor="let tpFrete of tiposDeFrete" [value]="tpFrete">{{
                                tpFrete }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field class="field-valor">
                            <mat-label>Frete</mat-label>
                            <input matInput [(ngModel)]="solicitacao.cotacao.vlFrete"
                              (input)="solicitacao.recalculaCabecalho()" placeholder="Frete"
                              name="vlFrete">
                            <span matPrefix>R$&nbsp;</span>
                          </mat-form-field>
                          <mat-form-field class="field-valor">
                            <mat-label>Valor Total</mat-label>
                            <input matInput [ngModel]="solicitacao.cotacao.vlTotal?.toFixed(2)"
                              placeholder="Valor Total" name="vlTotal" disabled>
                            <span matPrefix>R$&nbsp;</span>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="teste"></div>
            </div>
          </div>
        </div> 
    
        <div *ngIf="1 === abaAtual" id="itens">
          <form *ngIf="areAllLoadSuccess()" (ngSubmit)="sendAll()" (keydown.enter)="$event.preventDefault()">
            <div class="list custom-max-width">
              <div class="custom-toolbar-header cabecalho">
                <div class="line">
                  <div class="text-cd-item">Código</div>
                  <div *ngIf="mostrarTresCampos()" class="text-cd-fabricante">Cd. Fabricante</div>
                  <div *ngIf="mostrarUmCampo()" class="text-nm-item">Descrição</div>
                  <div *ngIf="mostrarTresCampos()" class="text-marca">Marca</div>
                  <div *ngIf="mostrarTresCampos()" class="text-ncm">NCM</div>
                  <div *ngIf="mostrarUmCampo()" class="text-qt-solicitada">Qtde Solicitada</div>
                  <div *ngIf="mostrarTresCampos()" class="text-qt-solicitada">Cod. Fornecedor</div>
                </div>
              </div>
  
              <div *ngFor="let cot of getTodosItensArray() | paginate: { itemsPerPage: 10, currentPage: page  }">
                <div *ngIf="todosItens[cot[0].solicitacaoCompraItem.item.cdItem].length > 1" class="espaco-item">
                  <mat-expansion-panel [expanded]="allExpandState">
                    <mat-expansion-panel-header class="item-cotacao" [expandedHeight]="'32px'" [collapsedHeight]="'28px'">
                      <div class="line">
                        <mat-panel-title class="text-cd-item">
                          <div class="text-cd-item"
                            [matTooltip]="cot[1].getCdItem(cot[0])"
                            tooltip-position="below">
                            {{cot[1].getCdItem(cot[0])}}
                          </div>
                        </mat-panel-title>
  
                        <mat-panel-title *ngIf="mostrarTresCampos() && cot[1].mostrarCdFabricante" class="text-cd-fabricante">
                          <div class="text-cd-fabricante"
                            [matTooltip]="cot[0].solicitacaoCompraItem.item.itemProduto.cdFabricante"
                            tooltip-position="below">
                            {{cot[0].solicitacaoCompraItem.item.itemProduto.cdFabricante}}
                          </div>
                        </mat-panel-title>
  
                        <mat-panel-title *ngIf="mostrarUmCampo()" class="text-nm-item">
                          <div class="text-nm-item" [matTooltip]="cot[0].solicitacaoCompraItem.item.nmItem" tooltip-position="below">
                            {{cot[0].solicitacaoCompraItem.item.nmItem}}
                          </div>
                        </mat-panel-title>
  
                        <mat-panel-title *ngIf="mostrarTresCampos()" class="text-marca">
                          <div class="text-marca">{{cot[0].solicitacaoCompraItem.item.itemProduto.marca.nmMarca}}</div>
                        </mat-panel-title>
  
                        <mat-panel-title *ngIf="mostrarTresCampos()" class="text-ncm">
                          <div class="text-ncm">{{cot[0].solicitacaoCompraItem.item.classificacaoFiscal.ncm}}</div>
                        </mat-panel-title>
  
                        <mat-panel-title *ngIf="mostrarUmCampo()" class="text-qt-solicitada">
                          <div class="text-qt-solicitada">{{qtdeTotal(cot[0].solicitacaoCompraItem.item.cdItem)}} {{cot[1].getUnMedida(cot[0])}}</div>
                        </mat-panel-title>
  
                        <mat-panel-title *ngIf="mostrarTresCampos()" class="text-qt-solicitada">
                          <div class="text-qt-solicitada">{{cot[1].getCdProdForn(cot[0])}}</div>
                        </mat-panel-title>
                      </div>
                    </mat-expansion-panel-header>
                  </mat-expansion-panel>
                </div>
                
                <!-- Cabeçalho do Itens -->
                <div *ngIf="todosItens[cot[0].solicitacaoCompraItem.item.cdItem].length === 1" class="espaco-item">
                  <mat-expansion-panel [expanded]="allExpandState">
                    <mat-expansion-panel-header class="item-cotacao" [expandedHeight]="'32px'" [collapsedHeight]="'28px'">										
                      <div class="line">
                        <mat-panel-title class="text-cd-item">
                          <div class="text-cd-item" [matTooltip]="cot[1].getCdItem(cot[0])" tooltip-position="below">
                            {{cot[1].getCdItem(cot[0])}}
                          </div>
                        </mat-panel-title>
                  
                        <mat-panel-title *ngIf="mostrarTresCampos()" class="text-cd-fabricante">
                          <div class="text-cd-fabricante" *ngIf="cot[1].mostrarCdFabricante" [matTooltip]="cot[0].solicitacaoCompraItem.item.itemProduto.cdFabricante"
                          tooltip-position="below">
                            {{cot[0].solicitacaoCompraItem.item.itemProduto.cdFabricante}}
                          </div>
                        </mat-panel-title>
                  
                        <mat-panel-title *ngIf="mostrarUmCampo()" class="text-nm-item">
                          <div class="text-nm-item" [matTooltip]="cot[0].solicitacaoCompraItem.item.nmItem" tooltip-position="below">
                            {{cot[0].solicitacaoCompraItem.item.nmItem}}
                          </div>
                        </mat-panel-title>
                  
                        <mat-panel-title *ngIf="mostrarTresCampos()" class="text-marca">
                          <div class="text-marca">{{cot[0].solicitacaoCompraItem.item.itemProduto.marca.nmMarca}}</div>
                        </mat-panel-title>
                  
                        <mat-panel-title *ngIf="mostrarTresCampos()" class="text-ncm">
                          <div class="text-ncm">{{cot[0].solicitacaoCompraItem.item.classificacaoFiscal.ncm}}</div>
                        </mat-panel-title>
                  
                        <mat-panel-title *ngIf="mostrarUmCampo()" class="text-qt-solicitada">
                          <div class="text-qt-solicitada">{{cot[0].solicitacaoCompraItem.qtSolicitada}} {{cot[1].getUnMedida(cot[0])}}</div>
                        </mat-panel-title>
                  
                        <mat-panel-title *ngIf="mostrarTresCampos()" class="text-qt-solicitada">								
                          <div class="text-qt-solicitada">{{cot[1].getCdProdForn(cot[0])}}</div>
                        </mat-panel-title>
                      </div>
                    </mat-expansion-panel-header>
                     <!-- Cabeçalho do Itens -->      
                    <form style="width: 100%;">

                      <div class="line" (focusout) = salvarItens(cot)>										
                      <mat-form-field class="mat-form-field small-font small-inputs">
                        <mat-label class="mat-label">Qtde</mat-label>
                        <input matInput [(ngModel)]="cot[0].qtCotacao" (input)="cot[1].recalculaItem(cot[0])" placeholder="Qtde" #qtde="ngModel"
                        name="qtde{{cot[0].idGeral}}">
                        <span matSuffix class="small-font-sufix">{{cot[1].getUnMedida(cot[0])}}</span>
                      </mat-form-field>
                      <mat-form-field class="mat-form-field-vl-total small-font small-inputs">
                        <mat-label class="mat-label">Valor Un.</mat-label>
                        <input matInput [(ngModel)]="cot[0].vlBruto" (input)="cot[1].recalculaItem(cot[0])" placeholder="Valor Un." name="valor{{cot[0].idGeral}}">
                        <span matPrefix class="small-font-sufix">R$&nbsp;</span>
                      </mat-form-field>
                      <mat-form-field class="mat-form-field-desconto small-font small-inputs">
                        <mat-label class="mat-label">Desconto</mat-label>
                        <input matInput [(ngModel)]="cot[0].pcDesconto" (input)="cot[1].recalculaItem(cot[0])" placeholder="Desconto" name="desc{{cot[0].idGeral}}">
                        <span matSuffix class="small-font-sufix">%</span>
                      </mat-form-field>
                      <mat-form-field class="mat-form-field small-font small-inputs">
                        <mat-label class="mat-label">Aliq. IPI</mat-label>
                        <input matInput [(ngModel)]="cot[0].ipiPcAliq" (input)="cot[1].recalculaItem(cot[0])" placeholder="Aliq. IPI" name="ipi{{cot[0].idGeral}}">
                        <span matSuffix class="small-font-sufix">%</span>
                      </mat-form-field>
                      <mat-form-field class="mat-form-field-icms small-font small-inputs">
                        <mat-label class="mat-label">Aliq. ICMS</mat-label>
                        <input matInput [(ngModel)]="cot[0].icmsPcAliq" (input)="cot[1].recalculaItem(cot[0])" placeholder="Aliq. ICMS" name="icmsAliq{{cot[0].idGeral}}">
                        <span matSuffix class="small-font-sufix">%</span>
                      </mat-form-field>
                      <mat-form-field class="mat-form-field-vl-icms small-font small-inputs">
                        <mat-label class="mat-label">Vl. ICMS</mat-label>
                        <input matInput [(ngModel)]="cot[0].icmsValor" (input)="cot[1].recalculaItem(cot[0], true)" placeholder="Vl. ICMS"
                        name="icmsValor{{cot[0].idGeral}}">
                        <span matPrefix class="small-font-sufix">R$&nbsp;</span>
                      </mat-form-field>
                      <mat-form-field class="mat-form-field-st small-font small-inputs">
                        <mat-label class="mat-label">Aliq. ST</mat-label>
                        <input matInput [(ngModel)]="cot[0].icmsStPcAliq" (input)="cot[1].recalculaItem(cot[0])" placeholder="Aliq. ST" name="icmsAliqSt{{cot[0].idGeral}}">
                        <span matSuffix class="small-font-sufix">%</span>
                      </mat-form-field>
                      <mat-form-field class="mat-form-field small-font small-inputs">
                        <mat-label class="mat-label">Vl. ST</mat-label>
                        <input matInput [(ngModel)]="cot[0].icmsStValor" (input)="cot[1].recalculaItem(cot[0], true)" placeholder="Vl. ST"
                        name="icmsValorSt{{cot[0].idGeral}}">
                        <span matPrefix class="small-font-sufix">R$&nbsp;</span>
                      </mat-form-field>
                      <mat-form-field class="mat-form-field-vl-total small-font small-inputs">
                        <mat-label class="mat-label">Vl. Total</mat-label>
                        <input matInput [ngModel]="cot[0].vlTotal?.toFixed(2)" placeholder="Vl. Total" name="vlTotal{{cot[0].idGeral}}" disabled>
                        <span matPrefix class="small-font-sufix">R$&nbsp;</span>
                      </mat-form-field>
                  
                      <mat-form-field class="mat-form-field-observacao small-font small-inputs">
                        <mat-label class="mat-label">Observação</mat-label>
                        <input matInput [(ngModel)]="cot[0].obs" placeholder="Observação" name="obs{{cot[0].idGeral}}" maxlength="300">
                      </mat-form-field>
                    </div>
                    <mat-form-field *ngIf="cot[1].filiais.length > 1" class="mat-form-field small-font small-inputs">
                        <mat-label class="mat-label">Filial</mat-label>
                        <mat-select [(ngModel)]="cot[0].fornecedorFaturamento" placeholder="Filial" name="filial{{cot[0].idGeral}}" class="select-filiais">
                          <mat-option *ngFor="let f of cot[1].filiais" [value]="f">{{f.nmCliente}} - {{f.cidade.uf}} - {{f.cnpjCpf}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    </form>         
                    
                  </mat-expansion-panel>
                </div>
              </div>
  
              <div class="align-text-center" id="final">
                <pagination-controls (pageChange)="page=$event" nextLabel="Próximo" previousLabel="Anterior">
                </pagination-controls>
              </div>
            </div>
          </form>
        </div>
        
        <div class="buttons" id="final">
          <button mat-raised-button (click)="sendAll()">SALVAR</button>				
          <button mat-raised-button color="primary" (click)="finalizaTodas()">FINALIZAR</button>
        </div>
  
  
        <div class="estilo-menu">
          <mat-grid-list style="position: relative; height: 100%;" rows="20" cols="1" rowHeight="22px">
            <mat-grid-tile *ngIf="1 === abaAtual" [rowspan]="2">
              <span class="expandir-mais">
                <button mat-mini-fab color="primary" mat-elevation-z4 (click)="allExpandState = true">
                  <mat-icon>unfold_more</mat-icon>
                </button>
              </span>
            </mat-grid-tile>
            <mat-grid-tile *ngIf="1 === abaAtual" [rowspan]="2">
              <span class="expandir-menos">
                <button mat-mini-fab color="primary" mat-elevation-z4 (click)="allExpandState = false">
                  <mat-icon>unfold_less</mat-icon>
                </button>
              </span>
            </mat-grid-tile>
            <mat-grid-tile *ngIf="1 === abaAtual" [rowspan]="4">
              <button class="ordenar" mat-mini-fab color="primary" (click)="showOl=!showOl">
                <mat-icon>reorder</mat-icon>
              </button>
            </mat-grid-tile>
            <mat-grid-tile [rowspan]="2">
              <span [ngClass]="{'inicio':true}">
                <button mat-mini-fab color="primary" mat-elevation-z4 id="goUpButton" (click)="scroll('topo')">
                  <mat-icon>expand_less</mat-icon>
                </button>
              </span>
            </mat-grid-tile>
            <mat-grid-tile [rowspan]="2">
              <span [ngClass]="{'final':true}">
                <button mat-mini-fab color="primary" mat-elevation-z4 id="goDownButton" (click)="scroll('final')">
                  <mat-icon>expand_more</mat-icon>
                </button>
              </span>
            </mat-grid-tile>
          </mat-grid-list>
        </div>			
      </div>
    </div>
    
    <form name="navForm">
      <div class="search-nav" layout="row" layout-align="center center" [ngStyle]="olStyle">
        <div class="disabled" (click)="showOl=!showOl"></div>
        <mat-card class="orderlist-margin">
          <mat-card-header fxLayoutAlign="center">
            <mat-card-title>Ordenar cotações</mat-card-title>
          </mat-card-header>
          <mat-divider></mat-divider>
    
          <mat-card-content>					
    
            <mat-card-subtitle style="margin: 10px 0px 10px 0px;" fxLayoutAlign="center" *ngIf="ol.listaEscolhido.length === 0">Adicione para ordenar</mat-card-subtitle>
    
            <mat-grid-list style="margin: 10px 0px 10px 0px;" *ngIf="ol.listaEscolhido.length > 0" cols="1" rowHeight="30px">
              <mat-grid-tile *ngFor="let op of ol.listaEscolhido">
              </mat-grid-tile>
            </mat-grid-list>
    
            <mat-divider></mat-divider>
    
            <mat-grid-list style="margin: 20px 0px 10px 0px;" cols="1" rowHeight="30px">
              <mat-grid-tile *ngFor="let op of ol.listaDisponivel">
              </mat-grid-tile>
            </mat-grid-list>
    
            <mat-divider style="margin: 10px;"></mat-divider>
          </mat-card-content>
        </mat-card>
      </div>
    </form>
  </div>
  </div>
</mat-sidenav-container>